import { render, staticRenderFns } from "./ResortsPage.vue?vue&type=template&id=53c8a343&"
import script from "./ResortsPage.vue?vue&type=script&lang=js&"
export * from "./ResortsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports